import React from 'react';
import { Timeline, Tween } from 'react-gsap';
import styles from './AudioRecorderAndPlay.module.scss';
import { t } from '../../translations';

export const PlayingBackAnimation = ({ maxRecordingLength }) => {
  const animation = [];
  animation.push(
    <svg
      key={'svg-0'}
      className="underlay"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      alt={t('pulsingAnimation')}
    >
      <rect
        width="188"
        height="188"
        x="10"
        y="10"
        rx="100"
        fill="transparent"
        strokeWidth="20"
        stroke="#CCC"
      />
    </svg>
  );
  animation.push(
    <Tween
      key={`frame-0`}
      wrapper={<svg version="1.1" xmlns="http://www.w3.org/2000/svg" />}
      from={{
        svgDraw: 0
      }}
      to={{
        svgDraw: 1
      }}
      duration={maxRecordingLength / 1000}
      ease={'Power0.easeNone'}
    >
      <rect
        width="188"
        height="188"
        x="10"
        y="10"
        rx="100"
        fill="transparent"
        strokeWidth="20"
        stroke="black"
      />
    </Tween>
  );
  const circles = 7;
  const duration = 2;
  const delay = duration / circles;
  for (let i = 1; i <= circles; i++) {
    animation.push(
      <Timeline
        key={`frame-${i}`}
        delay={delay * i}
        target={<div className={styles.pulseGray}></div>}
        repeat={-1}
      >
        <Tween
          from={{ scale: 0 }}
          to={{ scale: 1.6, autoAlpha: 0 }}
          duration={duration}
          ease={'Linear.easeOut'}
          yoyo={true}
        />
      </Timeline>
    );
  }

  return animation;
};
